var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30058_12804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9879 26.0117C21.9954 21.0233 25.9854 16.0358 34.4651 16.5345C34.9686 25.0142 29.9764 29.0042 24.9879 26.0117Z",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2944 27.0442C22.4319 23.4817 19.5819 19.9192 13.5247 20.2745C13.1684 26.3317 16.7319 29.1817 20.2944 27.0442Z",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 24L23.25 30",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 20.25L25.0078 25.9922C24.4505 26.5494 24.0084 27.2109 23.7068 27.9389C23.4052 28.6669 23.25 29.4473 23.25 30.2353V33",
    stroke: "#0F5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30058_12804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCrop);
export default __webpack_public_path__ + "static/media/activeCrop.4215eb7ee8e0ecc3cdf53be6a5f76aa5.svg";
export { ForwardRef as ReactComponent };